<template>
    <ModalDialog
        id="delete-modal"
        ref="modal"
        size="sm"
        :isLoading="isLoading"
        @submit="deleteBrand"
    >
        <template #header>
            {{ $t('delete') }} <b>{{ brand.name }}</b
            >?
        </template>

        <template #default>
            <Alerts style="margin: 20px 15px" />
        </template>

        <template #footer="{ close, submit }">
            <button
                class="btn btn-sm btn-default"
                type="button"
                data-dismiss="modal"
                :disabled="isLoading"
                @click="close"
            >
                {{ $t('cancel') }}
            </button>

            <button
                class="btn btn-sm btn-danger"
                :disabled="isLoading"
                @click="submit"
            >
                <i
                    v-if="isLoading"
                    class="fa fa-refresh fa-spin"
                />
                <span>{{ $t('delete') }}</span>
            </button>
        </template>
    </ModalDialog>
</template>

<script>
import EventBus from '@/event-bus';
import ModalDialog from '@/components/modals/ModalDialog.vue';

export default {
    components: {
        ModalDialog,
    },
    props: {
        brand: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isLoading: false,
        };
    },
    methods: {
        async deleteBrand() {
            try {
                this.isLoading = true;
                this.$emit('loading', this.isLoading);

                const {
                    data: { name },
                } = await axios.delete(`/brands/data/brand`, {
                    params: {
                        id: this.brand.id,
                    },
                });

                this.$refs.modal.close();

                await this.$emit('deleted', name);

                EventBus.$emit('alertData', {
                    class: 'alert-danger',
                    message: this.$t('messages.brand.deleted', { name }),
                });
            } catch (error) {
                EventBus.$emit('alertData', {
                    class: 'alert-danger',
                    message: error.response.data.message,
                    errors: error.response.data.errors,
                });
            } finally {
                this.isLoading = false;
                this.$emit('loading', this.isLoading);
            }
        },
    },
};
</script>
